import { request } from "./actions";
import {host} from '../utilities/requests';

const id_server_date = 'id_server_date';


export function ServerDate()
{
    if(serverDate!=null)
    {
        //if(serverDate.getTime()<recevedDate.getTime()+)
        //{
        return new Date(serverDate.getTime()+(new Date().getTime()-recevedDate.getTime()));
        //}
        //else
        //{
        //    getServerDateLater();
        //    return new Date();
        //}
    }
    else
    {
        return new Date();
    }
};

var serverDate = new Date();
var recevedDate = new Date();
var timeOutId=-1;
var serverDateLoade = false ;

export function isServerLoaded()
{
    return serverDateLoade;
}

export function ServerDateSetup()
{
    // debugger;
    
    loadServerDateFromCache();
    //return;
    fetch(host + '/api/server_time/')
        .then((response)=>response.json())
        .then((data)=>{
            // console.log('data : ',new Date(data.now*1000));
            serverDateLoade = true ;
            saveServerDate(data.now);
        })
        .catch(getServerDateLater);
}

function getServerDateLater()
{
    clearTimeout(timeOutId);
    timeOutId = setTimeout(ServerDateSetup,10000);
}


function saveServerDate(timeStamp=0)
{
    serverDate = new Date(timeStamp*1000);
    recevedDate = new Date();
    localStorage.setItem(
        id_server_date,
        serverDateObjectToJSON(
            serverDate,
            recevedDate
        )
    );
}

    function serverDateObjectToJSON(date=new Date(),receiveTime=new Date())
    {
        return JSON.stringify({d:date.getTime(),r:receiveTime.getTime()})
    }

function loadServerDateFromCache()
{
    var data = JSONToServerDate(localStorage.getItem(id_server_date));
    //var data = null;
    if(data!=null)
    {
        serverDateLoade = true ;
        serverDate = new Date(data.d);
        recevedDate = new Date(data.r);
    }
}

function JSONToServerDate(jsonString='')
{
    if(jsonString==null)
        return null;
    var data = {d:0,r:0}
    data = JSON.parse(jsonString);
    return data ;
}
export function PGetRealServerData(state,setState){
    let finalData;
    fetch(host + '/api/server_time/')
    .then((response)=>response.json())
    .then((data)=>{
        console.log("data",data);
        console.log(Number(data.now));
        // if(data.now){
        //     return 1;
        // }else{
        //     return 1        
        // } 
        return data      
    })
    .catch();
}